import { render, staticRenderFns } from "./VeiculosForm.vue?vue&type=template&id=70e3facf"
import script from "./VeiculosForm.vue?vue&type=script&lang=js"
export * from "./VeiculosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports